import { render, staticRenderFns } from "./ManageSelectedDevices.vue?vue&type=template&id=23d3dd70&scoped=true"
import script from "./ManageSelectedDevices.vue?vue&type=script&lang=ts"
export * from "./ManageSelectedDevices.vue?vue&type=script&lang=ts"
import style0 from "./ManageSelectedDevices.vue?vue&type=style&index=0&id=23d3dd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3dd70",
  null
  
)

export default component.exports